const Titlebanner = (props) => {
  return (
    <>
      <div className="banner-txt">
        <br />
        <h2>{props.title}</h2>
        <div class="banner-devicer"></div>
      </div>
    </>
  );
};

export default Titlebanner;
